// ไฟล์: frontend/src/pages/WriteArticlePage.js
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

const WriteArticlePage = ({ user }) => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [formData, setFormData] = useState({
    title: "",
    content: "",
    category_id: "",
    thumbnail: null,
  });
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingCategories, setLoadingCategories] = useState(true);

  // ดึงข้อมูลหมวดหมู่
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get("/categories");
        setCategories(response.data.categories);
        setLoadingCategories(false);
      } catch (error) {
        console.error("Error fetching categories:", error);
        setLoadingCategories(false);
      }
    };

    fetchCategories();
  }, []);

  // จัดการการเปลี่ยนแปลงข้อมูลในฟอร์ม
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // จัดการการเปลี่ยนแปลงไฟล์รูปภาพ
  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      setFormData({ ...formData, thumbnail: file });

      // สร้าง preview สำหรับรูปภาพ
      const reader = new FileReader();
      reader.onload = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // จัดการการส่งฟอร์ม
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !formData.title.trim() ||
      !formData.content.trim() ||
      !formData.category_id
    ) {
      Swal.fire({
        icon: "error",
        title: "กรุณากรอกข้อมูลให้ครบถ้วน",
        text: "กรุณากรอกหัวข้อ เนื้อหา และเลือกหมวดหมู่",
        confirmButtonText: "ตกลง",
        confirmButtonColor: "#3490dc",
      });
      return;
    }

    setLoading(true);

    // สร้าง FormData สำหรับส่งข้อมูล
    const data = new FormData();
    data.append("title", formData.title);
    data.append("content", formData.content);
    data.append("category_id", formData.category_id);

    if (formData.thumbnail) {
      data.append("thumbnail", formData.thumbnail);
    }

    try {
      const response = await axios.post("/articles", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      setLoading(false);

      Swal.fire({
        icon: "success",
        title: "สร้างบทความสำเร็จ!",
        text:
          user.role === "admin"
            ? "บทความของคุณถูกเผยแพร่เรียบร้อยแล้ว"
            : "บทความของคุณได้ถูกส่งไปเพื่อรออนุมัติ",
        confirmButtonText: "ตกลง",
        confirmButtonColor: "#3490dc",
      }).then(() => {
        navigate("/articles");
      });
    } catch (error) {
      setLoading(false);
      console.error("Error creating article:", error);

      Swal.fire({
        icon: "error",
        title: "เกิดข้อผิดพลาด!",
        text:
          error.response?.data?.message ||
          "ไม่สามารถสร้างบทความได้ กรุณาลองอีกครั้ง",
        confirmButtonText: "ตกลง",
        confirmButtonColor: "#3490dc",
      });
    }
  };

  if (loadingCategories) {
    return (
      <div className="container">
        {/* <div className="loading-spinner">กำลังโหลดข้อมูล...</div> */}
      </div>
    );
  }

  return (
    <div className="container">
      <div className="page-header">
        <h1 className="page-title">
          <i className="fas fa-pen-fancy"></i> เขียนบทความใหม่
        </h1>
        <p className="page-subtitle">
          แบ่งปันแนวคิด มุมมอง และประสบการณ์ในการจัดการเรียนการสอนของคุณ
        </p>
      </div>

      <div className="card shadow-lg">
        <div className="card-header">
          <i className="fas fa-edit"></i> แบบฟอร์มเขียนบทความ
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="title" className="form-label">
                หัวข้อบทความ <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                id="title"
                name="title"
                className="form-control"
                placeholder="เช่น เทคนิคการสร้างแรงจูงใจในห้องเรียน"
                value={formData.title}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="category_id" className="form-label">
                หมวดหมู่ <span className="text-danger">*</span>
              </label>
              <select
                id="category_id"
                name="category_id"
                className="form-select"
                value={formData.category_id}
                onChange={handleChange}
                required
              >
                <option value="">-- เลือกหมวดหมู่ --</option>
                {categories.map((category) => (
                  <option key={category.id} value={category.id}>
                    {category.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="thumbnail" className="form-label">
                รูปภาพประกอบ (ถ้ามี)
              </label>
              <input
                type="file"
                id="thumbnail"
                name="thumbnail"
                className="form-control"
                accept="image/*"
                onChange={handleFileChange}
              />
              <small className="text-muted">
                แนะนำขนาด 1200 x 630 พิกเซล (16:9)
              </small>

              {preview && (
                <div className="mt-3">
                  <div className="thumbnail-preview">
                    <img src={preview} alt="ตัวอย่างรูปภาพ" width={400} />
                  </div>
                </div>
              )}
            </div>

            <div className="form-group">
              <label htmlFor="content" className="form-label">
                เนื้อหาบทความ <span className="text-danger">*</span>
              </label>
              <textarea
                id="content"
                name="content"
                className="form-control"
                rows="15"
                placeholder="เขียนเนื้อหาบทความของคุณที่นี่..."
                value={formData.content}
                onChange={handleChange}
                required
              ></textarea>
            </div>

            <div className="form-group text-center mt-4">
              <button
                type="submit"
                className="btn btn-primary btn-lg"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <i className="fas fa-spinner fa-spin"></i> กำลังบันทึก...
                  </>
                ) : (
                  <>
                    <i className="fas fa-paper-plane"></i> เผยแพร่บทความ
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>

      <div className="article-guidelines mt-4">
        <h2>
          <i className="fas fa-lightbulb"></i> คำแนะนำในการเขียนบทความ
        </h2>
        <ul>
          <li>เขียนหัวข้อที่น่าสนใจและดึงดูดผู้อ่าน</li>
          <li>แบ่งเนื้อหาเป็นหัวข้อย่อยเพื่อให้อ่านง่าย</li>
          <li>เพิ่มตัวอย่างหรือกรณีศึกษาเพื่อให้บทความน่าสนใจ</li>
          <li>ตรวจสอบความถูกต้องของเนื้อหาและการสะกดคำ</li>
          <li>เขียนบทสรุปที่ชัดเจนในตอนท้าย</li>
        </ul>
      </div>
    </div>
  );
};

export default WriteArticlePage;
